module.exports = __webpack_public_path__ + "img/shuiz.991f4017.png";